<!-- Alphabet — the whole system on one screen.

     The chart teaches the SYSTEM, not just the shapes: A to D introduce the
     four directions, and the caption says how the pairs are built from them.
     A child who understands that can write without the chart, which is the
     point of learning a cipher at all. -->
<template>
  <IonPage>
    <IonContent :fullscreen="true" class="alphabet">
      <div class="sheet">
        <header class="head">
          <h1>The footprint alphabet</h1>
          <p>
            Four directions — down, right, up, left — make A, B, C and D. Every
            other letter is two prints: stacked for E to T, side by side for U
            onwards and the numbers.
          </p>
        </header>

        <div class="grid">
          <div v-for="g in cells" :key="g.character" class="cell">
            <svg viewBox="-24 -26 48 52" aria-hidden="true">
              <path v-for="(p, i) in g.prints" :key="i" :d="p.d" :transform="p.transform" fill="#6b4a2f" />
            </svg>
            <span>{{ g.character }}</span>
          </div>
        </div>

      </div>
    </IonContent>
  </IonPage>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { IonPage, IonContent } from '@ionic/vue';
import { CHARACTERS, TABLE, printsFor, ensureAlphabet } from '../alphabet.js';

onMounted(() => ensureAlphabet());

const cells = computed(() => CHARACTERS.split('').map((ch) => ({
  character: ch,
  prints: printsFor(TABLE[ch]),
})));
</script>

<style scoped>
.alphabet { --background: var(--fs-paper); }
.sheet {
  min-height: 100%; background: var(--fs-paper); color: var(--fs-ink);
  font-family: var(--fs-body);
  padding: calc(16px + env(safe-area-inset-top, 0px)) 0 calc(16px + env(safe-area-inset-bottom, 0px));
}
.head { padding: 0 20px; }
.head h1 { margin: 0; font-family: var(--fs-serif); font-style: italic; font-weight: 400; font-size: 28px; }
.head p { margin: 8px 0 0; font-size: 15px; line-height: 1.5; color: color-mix(in srgb, var(--fs-ink) 72%, transparent); }
.grid { display: grid; grid-template-columns: repeat(6, minmax(0, 1fr)); gap: 8px; padding: 16px; }
.cell {
  display: flex; flex-direction: column; align-items: center; gap: 1px;
  min-height: 66px; padding: 6px 0 4px;
  background: color-mix(in srgb, white 34%, transparent);
  border: 1px solid color-mix(in srgb, var(--fs-sepia) 20%, transparent);
  font-family: var(--fs-serif); font-size: 17px; font-weight: 600; color: var(--fs-ink);
}
.cell svg { width: 38px; height: 42px; }
</style>
